import getConfig from 'next/config';
const { environment } = getConfig().publicRuntimeConfig;

export type Environments = 'production' | 'development' | 'staging';

export const ENVIRONMENT = environment as Environments;
export const isServer = typeof window === 'undefined';
